import { gsap, SplitText, ScrollTrigger } from "@gsap";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
/**
 * Layout: Content - Slider
 * Slug: content_slider
 */

document.addEventListener("DOMContentLoaded", function () {	
	gsap.registerPlugin(ScrollTrigger, SplitText);
	const layouts = document.querySelectorAll(
		".flex-layout.content_slider-layout",
	);

	layouts.forEach((layout) => {
		let split = SplitText.create(layout.querySelector(".content-col .pk-heading-text"), { type: "lines" });

		gsap.to(split.lines[1], {
			xPercent: 20,
			scrollTrigger: {
				trigger: layout,
				scrub: false,
				start: "top center",
				end: "bottom center",
				toggleActions: "play reverse play reverse",
				markers: false
			}
		});

		const prevEl = layout.querySelector(".swiper-nav-prev");
		const nextEl = layout.querySelector(".swiper-nav-next");
		const swiper = new Swiper(layout.querySelector(".swiper-container"), {
			slidesPerView: 1,
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			navigation: {
				prevEl: prevEl,
				nextEl: nextEl,
			},
		});
	});
});
